import { render, staticRenderFns } from "./medicalForm.vue?vue&type=template&id=16fbfccd&scoped=true&"
import script from "./medicalForm.vue?vue&type=script&lang=js&"
export * from "./medicalForm.vue?vue&type=script&lang=js&"
import style0 from "./medicalForm.vue?vue&type=style&index=0&id=16fbfccd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fbfccd",
  null
  
)

export default component.exports